import React from "react";

import Chip from "../index";

export default function Job({ value, ...props }) {
  const items = {
    queued: {
      color: "default",
    },
    executing: {
      color: "primary",
    },
    finished: {
      color: "success",
    },
    retrying: {
      color: "warning",
    },
    failed: {
      color: "danger",
    },
  };

  const item = items[value] || {
    color: "default",
  };

  return (
    <Chip color={item.color} tooltip={item.tooltip} value={value} {...props} />
  );
}
